import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const PrivateRoute = () => {
    const { isAuth, isLoading } = useAuth();

    if (isLoading) {
        return <div>Загрузка...</div>; // ✅ Пока загружается токен — показываем "Загрузка..."
    }

    return isAuth ? <Outlet /> : <Navigate to="/" replace />;
};

export default PrivateRoute;
